import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private readonly canLog = environment.showLogs;

  log(message: string): void {
    if (this.canLog) {
      console.log(`%c[LOG]:`, 'color: #2196F3; font-weight: bold;', message);
    }
  }

  warn(message: string): void {
    if (this.canLog) {
      console.warn(`[WARN]: ${message}`);
    }
  }

  error(message: string): void {
    if (this.canLog) {
      console.error(`%c[ERROR]:`, 'color: #f44336; font-weight: bold;', message);
    }
  }
}
